import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AudiencesComponent } from '../audiences/audiences.component';
import { LoginComponent } from '../login/login.component';
import { AboutComponent } from '../about/about.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'about', component: AboutComponent },
  { path: '', component: AudiencesComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '' }
];
@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/routing/app-routing.ts